<template>
  <div class="w3ls-banner">
    <div class="center-container">
      <!-- 标题栏 -->
      <div class="navigation">
        <div class="container">
          <div class="navigation-right">
            <span class="menu">
              <img src="static/images/menu.png" alt=" " />
            </span>
            <nav class="link-effect-3" id="link-effect-3">
              <ul class="nav1 nav">
                <li class>
                  <a data-hover="Home" :href="`#/${d.meta.year}`">Home</a>
                </li>
                <li>
                  <a href="#Introduction" class="scroll" data-hover="Introduction">Introduction</a>
                </li>
                <li>
                  <a
                    href="#ImportantDates"
                    class="scroll"
                    data-hover="Important Dates"
                  >Important Dates</a>
                </li>
                <li>
                  <a
                    href="#CallForPaper"
                    class="scroll"
                    data-hover="Call for Paper"
                  >Call For Paper</a>
                </li>
                <li>
                  <a href="#Organization" class="scroll" data-hover="Organization">Organization</a>
                </li>
                <li>
                  <a href="#Submission" class="scroll" data-hover="Submission">Submission</a>
                </li>
                <li>
                  <a href="#Keynote" class="scroll" data-hover="Keynote">Keynote</a>
                </li>
                <li>
                  <a href="#Program" class="scroll" data-hover="Program">Program</a>
                </li>
              </ul>
            </nav>
          </div>
          <div class="clearfix"></div>
        </div>
      </div>
      <!-- 大图部分 -->
      <div
        class="w3ls_banner_info"
        :style="`background:url(${d.backgroundImage}) center center no-repeat;`"
      >
        <div class="container">
          <div class="w3l_banner_logo">
            <h2>IBF</h2>
          </div>
          <h3>The {{d.meta.session}} International Workshop on Intelligent Bug Fixing</h3>
          <p style="font-size: 1.3em">
            {{d.meta.date}}
            <br />
            {{d.meta.location}}
            <br />
            co-located with SANER {{d.meta.year}}
          </p>
          <div class="more">
            <a
              href="#"
              class="hvr-underline-from-center"
              data-toggle="modal"
              data-target="#myModal"
            >Learn More</a>
          </div>
          <!-- 弹窗 -->
          <div
            class="modal video-modal fade"
            id="myModal"
            tabindex="-1"
            role="dialog"
            aria-labelledby="myModal"
          >
            <div class="modal-dialog" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  Intelligent Bug Fixing
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  <img :src="d.learnMoreImage" alt=" " class="img-responsive" />
                  <p class="paragraph">
                    The {{d.meta.session}} International Workshop on Intelligent Bug Fixing (IBF) is the principal venue for works in the area of intelligent bug fixing. It focuses on how to fix bugs by using a series of intelligent technologies such as data mining, information retrieval, machine learning, natural language process, etc. In this workshop, we solicit high-quality contributions with consolidated and thoroughly evaluated application-oriented research results in the area of intelligent bug fixing that are worthy of archival publication in SANER {{d.meta.year}} workshop proceeding. IBF {{d.meta.year}} will be held in {{d.meta.location}} co-located with SANER {{d.meta.year}}.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Banner",
  props: {
    datum: {
      type: Object,
      default: function() {
        return {
          meta: {
            year: 2021,
            session: "third",
            date: "TBD",
            location: "TBD"
          },
          backgroundImage: ""
        };
      }
    }
  },
  data() {
    return {
      d: {
        ...this.datum
      }
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.center-container {
  padding: 0;
}
.w3ls_banner_info {
  padding: 0;
  .container {
    padding: 5em 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Banner.vue